<template>
  <span>
    <slot name="button" v-bind="{onclick: toggle}">
      <b-button variant="primary" class="mr-1" size="xs" @click="toggle"><i
          class="fas fa-edit"></i>&nbsp;Edit</b-button>
    </slot>

    <b-modal
        @show="resetModal"
        @hidden="resetModal"
        ref="modal-container"
        v-model="modalShow"
        size="lg"
        :title="title"
        :static="true"
        :lazy="true"
        hide-footer
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group :label="type !== 'checkbox' ? label : null" :label-for="`${id}-input`"
                      v-for="({id, label, validate = {}, type, disabled = false, options, placeholder = null}) in inputs"
                      :key="id">
          <b-form-input v-if="type === 'string'"
                        :id="`${id}-input`"
                        v-model="formValues[id]" v-validate="validate"
                        :placeholder="placeholder"
                        :state="validateState(id)" :aria-describedby="`${id}-live-feedback`" :data-vv-name="id"
                        :data-vv-as="label" autocomplete="off"
                        :disabled="disabled"
          />
          <b-form-input v-if="type === 'number'"
                        type="number"
                        :id="`${id}-input`"
                        v-model="formValues[id]" v-validate="validate"
                        :state="validateState(id)" :aria-describedby="`${id}-live-feedback`"
                        :data-vv-name="id"
                        :data-vv-as="label" autocomplete="off"
                        :disabled="disabled"
          />
          <multiselect
              v-if="type === 'select'"
              :id="`${id}-input`"
              v-model="gameTypeModel"
              v-validate="validate"
              label="name"
              track-by="id"
              :close-on-select="false"
              :options="options"
              :aria-describedby="`${id}-live-feedback`" :data-vv-name="id"
              :data-vv-as="label" autocomplete="off"
              :disabled="disabled"
              multiple="multiple"
          />
         <b-form-invalid-feedback id="value-editor-error-live-feedback"
                                  v-if="veeErrors.first('value-editor-error')">
          {{ valueEditorError }}
        </b-form-invalid-feedback>

        </b-form-group>
      </form>

      <b-button class="mt-2 float-right" variant="primary" @click="handleSubmit">Save</b-button>
    </b-modal>
  </span>
</template>

<script>
import {getRouteIcon, ROUTE_AGGR_CONFIGS} from "../../utils/routerIcons";
import Vue from "vue";
import Multiselect from "vue-multiselect";

export default {
  data() {
    return {
      gameTypeOption: [],
      modalShow: false,
      formValues: this.getInitialValues(),
      valueEditorError: '',
      gameTypeModel: [],
    }
  },
  components: {
    Multiselect

  },
  props: {
    create: Boolean,
    title: String,
    defaultValues: Object
  },
  methods: {
    validatorTag(tag) {
      return /^\d+\.?\d*$/.test(tag);
    },
    getInitialValues() {
      return {
        id: null,
        tables: null,
        name: '',
      };
    },
    setDefaults() {

      let initialValues = this.getInitialValues();

      for (let field in initialValues) {
        Vue.set(this.formValues, field, initialValues[field]);
      }
      if (this.defaultValues) {
        for (let field in this.defaultValues) {

          Vue.set(this.formValues, field, this.defaultValues[field]);
        }
      }
      if (null !== this.formValues.gameTypes && undefined !== this.formValues.gameTypes) {
        this.gameTypeModel = this.formValues.gameTypes.map((gameType) => this.gameTypeOption.find(({id}) => id === gameType))
      }
    },
    validateState(ref) {
      console.log(ref)
      // return this.veeErrors.has(ref);
      //
      // if (
      //     this.veeFields[ref] &&
      //     (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      // ) {
      //   return !this.veeErrors.has(ref);
      // }
      return null;
    },
    resetModal() {
      this.setDefaults();
    },
    hideModal() {
      this.$refs['modal-container'].hide();
    },
    toggle() {
      this.modalShow = !this.modalShow;
    },
    handleSubmit() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          return;
        }

        this
            .$http({
              url: this.create ? '/api/v1/provider-name' : '/api/v1/provider-name/' + this.formValues.id,
              data: {...this.formValues, gameTypes: this.gameTypeModel.map(({id}) => id)},
              method: this.create ? 'POST' : 'PUT',
              headers: {
                'Content-Type': 'application/json',
              },
            })
            .then(() => {
              setTimeout(() => {
                this.$emit('finish')
              }, 500);

              this.hideModal();
              this.$toastr.i('Success');
            })
            .catch((err) => {
              this.$toastr.e(JSON.stringify(err.response.data.message));

              throw err;
            });
      });
    },
  },
  computed: {
    inputs() {
      let inputs = [
        {id: 'name', label: 'Name', validate: {required: true}, type: 'string'},
        {
          id: 'gameTypes',
          label: 'Game Types',
          options: this.gameTypeOption,
          validate: {required: false},
          type: 'select'
        },
        {id: 'tableIdMin', label: 'Table Id Min', validate: {required: true}, type: 'number'},
        {id: 'tableIdMax', label: 'Table Id Max', validate: {required: true}, type: 'number'},
      ];

      if (this.create) {
        return inputs;
      }

      return [
        {id: 'id', label: '_ID', validate: {required: true}, type: 'string', disabled: true},
        ...inputs,
      ];
    },
    routeIcon: () => getRouteIcon(ROUTE_AGGR_CONFIGS),
  },
  async beforeMount() {
    await this.$store.dispatch('gameTypes/loadList').then(() => {
      this.gameTypeOption = this.$store.getters['gameTypes/list'].map(({name, id}) => {
        return {name, id}
      });
    });
  },
  mounted() {
    this.setDefaults();
  },
}
</script>
